module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.14 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Now disabled item also emits event:on-item-click #1144")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/form-preview.html"
    }
  }, [_vm._v("FormPreview")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix variable: form-preview-button-primary-color")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support prop:name #1123")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/masker.html"
    }
  }, [_vm._v("Masker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:fullscreen")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix can not set Selector name attrbiute bug #1133")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Selector value support Boolean. @rbao")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix left-menu is shown when sliding back and forth #1139")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix cannot set value to true initially #1138")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-462b99c1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-462b99c1"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.14-89.vue
// module id = 2688
// module chunks = 385